import { React, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import CardBlue from "../../components/Card/CardBlue";

import PublicShowcaseTab from "../../components/Navbar/PublicShowcaseTab";
import PublicCardPostNew from "../../components/Card/PublicCardPostNew";
import noDataAvailableImg from "../../common/images-new/no-data-available.png";
import { CommonLoader } from "../../components/Button/Loader";
export default function PublicShowcaseContainer({
  profile,
  data,
  isGuest,
  guestCode,
  isPublicProfileURL,
  src,
  ...props
}) {
  const [currentShowcase, setCurrentShowcase] = useState(0);
  const isLoading = useSelector((state) => state.showcase.isLoading);
  const currentState = useSelector((state) => state.showcase.currentSelected);
  const [selectedShowcase, setSelectedShowcase] = useState({});

  const location = useLocation();

  useEffect(() => {
    try {
      setSelectedShowcase(data[currentShowcase]);
    } catch (err) {}
  }, [data, currentShowcase]);
  useEffect(() => {
    if (currentState) {
      setCurrentShowcase(currentState);
    }
  }, []);
  const dispatch = useDispatch();

  useEffect(() => {
    if (location.state) {
      const tabId = location.state.tabId ? location.state.tabId : 0;

      const selectedTab = data.findIndex(
        (showcaseData) => showcaseData.id === tabId
      );

      if (selectedTab !== -1) {
        setCurrentShowcase(selectedTab);
      }
    }
  }, [data, location]);

  const showSelectedShowcasePost = (index) => {
    dispatch({ type: "currentSelectedPublic", payload: index });
    setCurrentShowcase(index);
  };

  const handleLikePost = (postId, isLiked) => {
    props.likePost && props.likePost(postId, isLiked);
  };

  const handleAddComment = (postId, isLiked) => {
    props.addComment && props.addComment(postId);
  };

  return (
    <div className="cardBackgroundColor p-6 rounded-lg">
      <div className="flex flex-row items-center ">
        <PublicShowcaseTab
          data={data}
          selectedId={currentShowcase}
          setPage={showSelectedShowcasePost}
        />
      </div>

      <hr className="" />

      {/* Showcase Body */}
      <div className="my-3 mx-3 md:mx-0 mt-7 md:mt-0">
        <CardBlue data={selectedShowcase} publicView={true} />
      </div>
      {!isLoading && selectedShowcase ? (
        <div className="flex flex-col">
          {selectedShowcase?.posts?.length > 0 ? (
            selectedShowcase.posts.map((post, idx) => (
              <PublicCardPostNew
                key={idx}
                post={post}
                profile={profile}
                tabId={data[currentShowcase].id}
                likePost={handleLikePost}
                addComment={handleAddComment}
                isGuest={isGuest}
                guestCode={guestCode}
                isPublicProfileURL={isPublicProfileURL}
                src={src}
              />
            ))
          ) : (
            <div className="w-full flex items-center justify-center h-full">
              <div className="w-full flex items-center justify-center h-full">
                <img
                  src={noDataAvailableImg}
                  alt="pics"
                  className="overflow-hidden w-52"
                />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="w-full flex justify-center">
          <CommonLoader />
        </div>
      )}
    </div>
  );
}
// import { React, useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// import CardBlue from "../../components/Card/CardBlue";

// import PublicShowcaseTab from "../../components/Navbar/PublicShowcaseTab";
// import PublicCardPost from "../../components/Card/PublicCardPost";
// import { staticFiles } from "../../components/Helpers/Static";

// export default function PublicShowcaseContainer({ profile, data, isGuest, guestCode, ...props }) {
//     const [currentShowcase, setCurrentShowcase] = useState(0)
//     const isLoading = useSelector(state => state.showcase.isLoading)
//     const [selectedShowcase, setSelectedShowcase] = useState({});

//     const location = useLocation();

//     useEffect(() => {
//         try {
//             setSelectedShowcase(data[currentShowcase])
//         }
//         catch (err) {}

//     }, [data, currentShowcase])

//     useEffect(() => {
//         if (location.state) {
//             const tabId = location.state.tabId ? location.state.tabId : 0;

//             const selectedTab = data.findIndex(showcaseData => showcaseData.id === tabId);

//             if (selectedTab !== -1) {
//                 setCurrentShowcase(selectedTab)
//             }
//         }
//     }, [data, location]);

//     const showSelectedShowcasePost = (index) => {
//         setCurrentShowcase(index)
//     }

//     const handleLikePost = (postId, isLiked) => {
//         props.likePost && props.likePost(postId, isLiked)
//     }

//     const handleAddComment = (postId, isLiked) => {
//         props.addComment && props.addComment(postId)
//     }

//     return (
//         <div>
//             <div className="flex flex-row items-center">
//                 <PublicShowcaseTab
//                     data={data}
//                     selectedId={currentShowcase}
//                     setPage={showSelectedShowcasePost}
//                 />
//             </div>

//             <hr className=""/>

//             {/* Showcase Body */}
//             <div className="my-3 mx-3 md:mx-0 mt-7 md:mt-0">
//                 <CardBlue
//                     data={selectedShowcase}
//                     publicView={true}

//                 />
//             </div>
//             {
//                 (!isLoading && selectedShowcase) ?
//                 <div className="flex flex-col">
//                     {
//                         selectedShowcase.posts &&
//                         selectedShowcase.posts.map((post, idx) => (
//                             <PublicCardPost
//                                 key={idx}
//                                 post={post}
//                                 profile={profile}
//                                 tabId={data[currentShowcase].id}
//                                 likePost={handleLikePost}
//                                 addComment={handleAddComment}
//                                 isGuest={isGuest}
//                                 guestCode={guestCode}
//                             />
//                         ))
//                     }

//                 </div>
//                 :
//                 <div className='w-full flex justify-center'>
//                     <img src={staticFiles.loading} alt='Loading...' className='w-10 h-10' />
//                 </div>
//             }
//         </div>
//     )
// }
